import { Typography, withStyles } from "@material-ui/core";
import { BlocTextes, Card } from "bc-front-sagacomponents";
import React from "react";
import { formatDateCourt } from "../../../helpers/formatters";
import { AdhesionAdherentParticulierResponse } from "../../../services/Api/swagger";
import { useAvantage } from "../hooks/avantage";
import styles from "../style";

interface Props {
  classes?: any;
  selectedAdhesion?: AdhesionAdherentParticulierResponse;
}
const AvantagesContent = (props: Props) => {
  const { classes, selectedAdhesion } = props;

  const {
    assistance,
    assurance,
    informations,
    selectedProgramme,
  } = useAvantage();
  return (
    <div className={classes.blocAvantages}>
      <Card>
        <div className={classes.containerTitle}>
          <Typography variant="h4">
            {selectedProgramme && selectedProgramme.libelle}
          </Typography>
          {selectedAdhesion?.dateEcheance && (
            <Typography variant="body1" className={classes.dateEcheance}>
              Valable jusqu'au {formatDateCourt(selectedAdhesion?.dateEcheance)}
            </Typography>
          )}
        </div>
        {assistance && assistance.length > 0 && (
          <BlocTextes
            red
            size="l"
            title="Assistance"
            content={assistance.map((item) => ({
              title: item.libelle,
              value:
                ((item.montant && item.montant.toString().replace(".0", "")) ||
                  "-") +
                " " +
                item.unite,
            }))}
          />
        )}
        {assurance && assurance.length > 0 && (
          <BlocTextes
            red
            size="l"
            title="Assurance"
            content={assurance.map((item) => ({
              title: item.libelle,
              value:
                ((item.montant && item.montant.toString().replace(".0", "")) ||
                  "-") +
                " " +
                item.unite,
            }))}
          />
        )}
        {informations && informations.length > 0 && (
          <BlocTextes
            red
            size="l"
            title="Informations"
            content={informations.map((item) => ({
              title: item.libelle,
              value:
                ((item.montant && item.montant.toString().replace(".0", "")) ||
                  "-") +
                " " +
                item.unite,
            }))}
          />
        )}
        <p className={classes.textInfo}>
          Pour plus d'informations, nous vous invitons à télécharger votre
          contrat.
        </p>
      </Card>
    </div>
  );
};
export default withStyles(styles)(AvantagesContent);
